import React from 'react';
import {observer} from 'mobx-react';
import {TimeSpan} from '@sparkware/app-utils';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {JackpotWidgetClockBox} from './boxes/footer/clock/box/jackpot-widget-clock.box';
import {JackpotType} from '../../services/jackpots/jackpot.constants';
import {JACKPOT_WIDGET_LAYOUT} from './jackpot-widget.component';
import {ComponentServicesPick} from "../../services/component-services-pick";
import {withServices} from "../../react-hooks/with-services";
import {NullableJackpotViewModel} from "../../services/jackpots/models/jackpot.view-model.interface";

interface IDailyJackpotWidgetClockComponentProps extends ComponentServicesPick<'jackpots' | 'time'>{
    jackpot: NullableJackpotViewModel;
    layout: JACKPOT_WIDGET_LAYOUT;
    widgetWidth?: number;
    jackpotType: JackpotType;
}


@observer
class ComponentBody extends OrbitComponent<IDailyJackpotWidgetClockComponentProps> {

    private getClockValue() {

        const mustHitDate = this.props.jackpot?.mustHitTime;

        if(!mustHitDate) {
            return '';
        }

        const currentDate = this.props.time.getCurrentDate();
        const seconds = Math.round((mustHitDate.getTime() - currentDate.getTime())/1000);
        const remainingTimeTimeSp = TimeSpan.fromSeconds(Math.max(0, seconds));
        return remainingTimeTimeSp.toString({useTotalHours: true});
    }



    render() {
        return <JackpotWidgetClockBox
            className="cy-daily-jackpot-clock"
            layout={this.props.layout}
            widgetWidth={this.props.widgetWidth}
            themeType={this.props.jackpots.getThemeType(this.props.jackpotType)}
            isDaily={this.props.jackpotType === JackpotType.Daily}
        >
            {this.getClockValue()}
        </JackpotWidgetClockBox>;
    }
}

export const JackpotWidgetClockComponent = withServices(ComponentBody, ['jackpots', 'time']);